import * as Config from './config';

const prolineAppDataKey = Config.getProlineAppDataKey();
/*!
 * loadProlineAppData from local storage
 * as a fallback create empty object
 */
const loadProlineAppData = function () {
    const appDataJSON = window.localStorage.getItem(prolineAppDataKey);
    try {
        window.prolineApp.prolineAppData = appDataJSON ? JSON.parse(appDataJSON) : {};
    } catch (e) {
        window.prolineApp.prolineAppData = {};
    }
};

/*!
 * saveProlineAppData (implicitly) fires window.storage event.
 */
const saveProlineAppData = function (data) {
    window.localStorage.setItem(window.prolineApp.prolineAppDataKey, JSON.stringify(data));
};

/*!
 * updateProlineAppData set selected key with given Value and save in localStorage
 */
const updateProlineAppData = function (key, newValue) {
    if (typeof key !== 'undefined' && typeof newValue !== 'undefined') {
        loadProlineAppData();
        window.prolineApp.prolineAppData[key] = newValue;
        saveProlineAppData(window.prolineApp.prolineAppData);
    }
};

export {loadProlineAppData, saveProlineAppData, updateProlineAppData}
